import { Assistant } from "@inrev/assistant";
import { createParser, type EventSourceMessage } from "eventsource-parser";
import { drainEventStream } from "../../utils/drainEventStream";

export const parseAssistantStream = async (
	response: Response,
	onEvent: (event: Assistant.Dtos.Turn.Event) => void,
	signal?: AbortSignal,
): Promise<void> => {
	const parser = createParser({
		onEvent(message: EventSourceMessage) {
			if (message.data === undefined || message.data === "") return;
			let payload: unknown;
			try {
				payload = JSON.parse(message.data);
			} catch {
				return;
			}
			const parsed = Assistant.Dtos.Turn.Event.schema.safeParse(payload);
			if (parsed.success) onEvent(parsed.data);
		},
	});

	if (response.body === null) return;

	try {
		await drainEventStream(response.body, parser, signal);
	} catch (error) {
		if (signal?.aborted) return;
		throw error;
	}
};
